import { Subtitle2Text } from '@/utils/global-fonts';
import styled from 'styled-components';

const TabContainer = styled.div`
  display: flex;
`;

const Tab = styled.button`
  border-radius: 4px;
  height: 32px;
  margin: 0px 2px 0px 2px;
  background-color: ${({ $active, theme }) =>
    $active ? theme.COLOR_PRIMARY : 'transparent'};
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  outline: none;
  min-width: 72px;
  overflow: hidden;
  white-space: nowrap;
  color: ${({ $active, theme }) =>
    $active ? theme.COLOR_WHITE : theme.COLOR_BLACK};
  text-overflow: ellipsis;
  border: ${({ $hasError, theme }) =>
    $hasError
      ? `2px solid ${theme.COLOR_ERROR_TEXT}`
      : `1px solid ${theme.COLOR_GREY5}`};
  align-items: center;
  justify-content: center;
`;

const Label = styled(Subtitle2Text)`
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? '700' : '400')};
  font-family: 'Inter', sans-serif;
  letter-spacing: 0.4px;
  color: ${({ $active, theme }) =>
    $active ? theme.COLOR_WHITE : theme.COLOR_BLACK};
  padding: 2px 6px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const DisplayActiveContent = styled.div`
  display: ${({ $active }) => ($active ? 'block' : 'none')};
`;

const TabSelectorStyle = {
  TabContainer,
  Tab,
  Label,
  DisplayActiveContent,
};

export default TabSelectorStyle;
